import { ChangeDetectorRef, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTable, MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "src/app/notifications/notification.service";
import { SessionService } from "src/app/session.service";
import { AreYouSureDialogComponent } from "src/app/shared/dialogs/are-you-sure-dialog/are-you-sure-dialog.component";
import { FilterTableDialogComponent } from "src/app/shared/dialogs/filter-table-dialog/filter-table-dialog.component";
import { UiService } from "src/app/ui/ui.service";
import { BeaconDTO } from "../Beacon";
import { BeaconService } from "../beacon.service";
import { pageSizeOptions } from "src/app/shared/utils/pagination";
import { BehaviorSubject, merge, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  first,
  switchMap,
  takeUntil,
  tap,
} from "rxjs/operators";
import { DataSource } from "@angular/cdk/table";
import { ElementLoaderDirective } from "src/app/ui/element-loader/element-loader.directive";
import { CollectionViewer } from "@angular/cdk/collections";
import { FormControl } from "@angular/forms";
import { LocalStorageService } from "src/app/storage/local-storage.service";
@Component({
  selector: "app-beacons-list",
  templateUrl: "./beacons-list.component.html",
  styleUrls: ["./beacons-list.component.scss"],
})
export class BeaconsListComponent implements OnInit {
  pageSizeOptions = pageSizeOptions;
  searchValueControl = new FormControl("");
  beacons!: BeaconDTO[];
  // beaconDataSource!: MatTableDataSource<any>;
  columns = [
    { code: "id", name: "ID" },
    { code: "name", name: "Beacon Name", filter: true, selected: true },
    {
      code: "facility_floors.name",
      name: "Facility Floor",
      filter: true,
      selected: true,
    },
    { code: "options" },
  ];
  displayedColumns = this.columns.map((column) => column.code);
  @ViewChild("beaconsTable") beaconsTable!: MatTable<any[]>;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  hasBeaconsWrite: boolean = false;
  hasBeaconsDetail: boolean = false;
  hasFacilitiesList: boolean = false;
  hasBeaconRegionsList: boolean = false;
  private onComponentDestroy = new Subject();
  @ViewChild(ElementLoaderDirective)
  beaconElementLoader!: ElementLoaderDirective;
  beaconsDataSource!: BeaconsDataSource;
  onFilterColumnChange = new Subject();
  perPage: number = 20;

  constructor(
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    private BeaconService: BeaconService,
    private SessionService: SessionService,
    private NotificationService: NotificationService,
    private uiService: UiService,
    private ChangeDetectorRef: ChangeDetectorRef,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    // this.beacons = this.activatedRoute.snapshot.data.beacons.records;
    // this.beaconDataSource = new MatTableDataSource(this.beacons);
    // this.beaconDataSource.filterPredicate = (data: any, filter: string) => {
    //   let found = false;
    //   for (let column of this.selectedColumns) {
    //     let rowValue = data[column];
    //     if (typeof rowValue === "number") {
    //       rowValue = rowValue.toString();
    //     }
    //     if (typeof rowValue === "string") {
    //       if (rowValue?.trim().toLowerCase().indexOf(filter) !== -1) {
    //         found = true;
    //       }
    //     }
    //   }

    //   return found;
    // };

    this.perPage = this.localStorageSvc.pageSize || 20;

    this.hasBeaconsWrite =
      this.activatedRoute.snapshot.data.permissions.hasBeaconsWrite;
    this.hasBeaconsDetail =
      this.activatedRoute.snapshot.data.permissions.hasBeaconsDetail;

    this.hasFacilitiesList =
      this.activatedRoute.snapshot.data.permissions.hasFacilitiesList;
    this.hasBeaconRegionsList =
      this.activatedRoute.snapshot.data.permissions.hasBeaconRegionsList;
  }

  ngAfterViewInit() {
    // this.beaconsTable.renderRows();
    // this.beaconDataSource.sort = this.sort;
    // this.beaconDataSource.paginator = this.paginator;

    this.beaconsDataSource = new BeaconsDataSource(
      this.BeaconService,
      this.paginator,
      this.beaconElementLoader,
    );

    this.loadBeaconsPage().pipe(first()).subscribe();

    merge(
      this.sort.sortChange.pipe(tap(() => (this.paginator.pageIndex = 0))),
      this.paginator.page,
      this.onFilterColumnChange,
      this.searchValueControl.valueChanges.pipe(
        distinctUntilChanged(),
        tap(() => (this.paginator.pageIndex = 0)),
      ),
    )
      .pipe(
        debounceTime(300),
        switchMap(() => this.loadBeaconsPage().pipe(first())),
        takeUntil(this.onComponentDestroy),
      )
      .subscribe();

    this.ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get currentAccount() {
    return this.SessionService.currentAccountValue;
  }

  get showCreate() {
    return (
      this.hasBeaconsWrite &&
      this.hasFacilitiesList &&
      this.hasBeaconRegionsList
    );
  }

  get showEdit() {
    return (
      this.hasBeaconsWrite &&
      this.hasBeaconsDetail &&
      this.hasFacilitiesList &&
      this.hasBeaconRegionsList
    );
  }

  get showDelete() {
    return this.hasBeaconsWrite;
  }

  applyFilter() {
    // this.beaconDataSource.filter = this.searchValue.trim().toLowerCase();
  }

  createNewBeacon() {
    this.router.navigate(["create"], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  toggleFilterDialog() {
    this.dialog
      .open(FilterTableDialogComponent, {
        data: {
          columns: this.columns,
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.columns = result;
          this.onFilterColumnChange.next();
        }
      });
  }

  edit(beacon: BeaconDTO) {
    this.router.navigate([beacon.id], {
      relativeTo: this.activatedRoute.parent,
    });
  }

  delete(beacon: BeaconDTO) {
    this.dialog
      .open(AreYouSureDialogComponent, {
        data: {
          areYouSureInfo: {
            description: `Are you sure you want to delete this beacon ( ${beacon.name} )?`,
            warning: "Warning: this is not reversible!",
          },
        },
      })
      .afterClosed()
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe((result) => {
        if (result) {
          this.uiService
            .waitForEvent(
              this.BeaconService.deleteBeacon(
                this.currentAccount!.accountID,
                beacon.id,
              ),
            )
            .pipe(takeUntil(this.onComponentDestroy))
            .subscribe(
              () => {
                this.NotificationService.openSuccessSnackBar("Beacon deleted");
                this.loadBeaconsPage().pipe(first()).subscribe();
              },
              () => {
                this.NotificationService.openErrorSnackBar(
                  "Error deleting beacon",
                );
              },
            );
        }
      });
  }

  loadBeaconsPage() {
    const sort = this.buildSort();

    return this.beaconsDataSource.loadBeacons(
      this.SessionService.currentAccountValue!.accountID,
      {
        page: this.paginator.pageIndex,
        perPage: this.paginator.pageSize,
        keyword: this.searchValueControl.value ?? "",
        forCount: true,
        sort,
        filter_columns: this.columns
          .filter((column) => column.selected)
          .map((column) => column.code),
      },
    );
  }

  buildSort() {
    const sort = [];
    if (this.sort.direction.length) {
      sort.push(`${this.sort.active}:${this.sort.direction}`);
    }
    return sort;
  }

  onPageChange(e: PageEvent){
    this.localStorageSvc.pageSize = e.pageSize;
    this.perPage = e.pageSize;
  }
}

export class BeaconsDataSource implements DataSource<any> {
  private beaconSubject = new BehaviorSubject<any[]>([]);

  constructor(
    private BeaconService: BeaconService,
    private paginator: MatPaginator,
    private beaconsElementLoader: ElementLoaderDirective,
  ) {}

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.beaconSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer) {
    this.beaconSubject.complete();
  }

  loadBeacons(masterAccountID: number, queryParams: any) {
    return this.beaconsElementLoader
      .waitForEvent(
        this.BeaconService.getBeacons(masterAccountID, queryParams).pipe(
          catchError(() => of({ count: 0, records: [] })),
        ),
      )
      .pipe(
        tap((filter: any) => {
          this.paginator.length = filter.count;
          const records = filter.records;

          this.beaconSubject.next(records);
        }),
      );
  }
}
